import { Box, Flex, Title } from "@mantine/core";
import MetadataFeedback from "src/components/MetadataFeedback";

export const FeedbackRoute = () => {
    return (
        <Flex p="xl" direction="column" gap="md">
            <Flex justify="space-between">
                <Title lh={2} c="purple.8" order={2} style={{ textTransform: "uppercase" }}>
                    Feedback
                </Title>
            </Flex>
            <Box>
                <MetadataFeedback />
            </Box>
        </Flex>
    );
};
